import { Injectable } from '@angular/core';
import {
    SwUpdate,
    VersionEvent,
    VersionReadyEvent,
    VersionDetectedEvent,
    VersionInstallationFailedEvent
} from '@angular/service-worker';
import { interval } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CacheService {

    private readonly UPDATE_CHECK_INTERVAL = 6 * 60 * 60;
    private readonly RELOAD_GUARD_KEY = 'pwa_update_reload_in_progress';

    constructor(private updates: SwUpdate) {
        if (this.updates.isEnabled) {
            // O interval do RxJS é em milissegundos.
            interval(this.UPDATE_CHECK_INTERVAL).subscribe(() => {
                this.checkNow();
            });

            this.updates.unrecoverable.subscribe(event => {
                console.error('[PWA] Estado irrecuperável detectado:', event.reason);
            });
        }
    }

    public checkForUpdates(): void {
        if (!this.updates.isEnabled) {
            console.log('[PWA] Service Worker desabilitado neste ambiente.');
            return;
        }

        this.updates.versionUpdates.subscribe({
            next: (event: VersionEvent) => {
                console.log('[PWA] versionUpdates event:', event);

                switch (event.type) {
                    case 'VERSION_DETECTED':
                        this.onVersionDetected(event as VersionDetectedEvent);
                        break;

                    case 'VERSION_READY':
                        this.onVersionReady(event as VersionReadyEvent);
                        break;

                    case 'VERSION_INSTALLATION_FAILED':
                        this.onVersionInstallationFailed(event as VersionInstallationFailedEvent);
                        break;

                    default:
                        console.log('[PWA] Evento não tratado:', event);
                        break;
                }
            },
            error: (error) => {
                console.error('[PWA] Erro ao ouvir versionUpdates:', error);
            }
        });
    }

    public checkNow(): void {
        if (!this.updates.isEnabled) {
            return;
        }

        this.updates.checkForUpdate()
            .then((hasUpdate) => {
                console.log('[PWA] checkForUpdate concluído. Nova versão disponível?', hasUpdate);
            })
            .catch((error) => {
                console.error('[PWA] Erro ao verificar atualização:', error);
            });
    }

    private onVersionDetected(event: VersionDetectedEvent): void {
        console.log('[PWA] Nova versão detectada. Hash:', event.version.hash);
    }

    private onVersionReady(event: VersionReadyEvent): void {
        console.log('[PWA] Nova versão pronta.');
        console.log('[PWA] Versão atual:', event.currentVersion.hash);
        console.log('[PWA] Nova versão:', event.latestVersion.hash);

        const reloadAlreadyTriggered = sessionStorage.getItem(this.RELOAD_GUARD_KEY) === 'true';

        // Evita reload em loop na mesma aba.
        if (reloadAlreadyTriggered) {
            console.warn('[PWA] Reload já foi disparado nesta sessão da aba. Ignorando novo reload.');
            return;
        }

        sessionStorage.setItem(this.RELOAD_GUARD_KEY, 'true');

        this.updates.activateUpdate()
            .then(() => {
                console.log('[PWA] Update ativado. Recarregando aplicação...');
                document.location.reload();
            })
            .catch((error) => {
                console.error('[PWA] Erro ao ativar update:', error);
                sessionStorage.removeItem(this.RELOAD_GUARD_KEY);
            });
    }

    private onVersionInstallationFailed(event: VersionInstallationFailedEvent): void {
        console.error('[PWA] Falha ao instalar nova versão:', event);
    }
}